import { render } from "./AcceptJoinUs.vue?vue&type=template&id=4aa3fffe"
import script from "./AcceptJoinUs.vue?vue&type=script&lang=js"
export * from "./AcceptJoinUs.vue?vue&type=script&lang=js"

import "./AcceptJoinUs.vue?vue&type=style&index=0&id=4aa3fffe&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__